import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useAuth } from '../context/AuthContext'
import {
  buildAnalyticsUserContext,
  buildPageContext,
  pushAnalyticsEvent,
  readConsentState,
  setAnalyticsUserContext,
} from './dataLayer'

const getRouteKey = (location = {}) => {
  const pathname = typeof location.pathname === 'string' ? location.pathname : ''
  const search = typeof location.search === 'string' ? location.search : ''
  return `${pathname}${search}`
}

const AnalyticsPageviewTracker = ({ location }) => {
  const { user, access, hydrated } = useAuth()
  const previousRouteKey = useRef('')
  const scheduledRouteKey = useRef('')
  const routeKey = getRouteKey(location)

  useEffect(() => {
    if (!hydrated || typeof window === 'undefined') return undefined

    if (
      !routeKey ||
      previousRouteKey.current === routeKey ||
      scheduledRouteKey.current === routeKey
    ) return undefined

    scheduledRouteKey.current = routeKey

    const timeoutId = window.setTimeout(() => {
      const page = buildPageContext({ location })
      scheduledRouteKey.current = ''
      if (!page?.path) return

      previousRouteKey.current = routeKey
      setAnalyticsUserContext(buildAnalyticsUserContext(user, { access }))

      const consent = readConsentState()
      pushAnalyticsEvent('virtual_page_view', {
        page,
        ...(consent ? { consent } : null),
        interaction: { type: 'route_change' },
      })
    }, 75)

    return () => {
      if (scheduledRouteKey.current === routeKey) scheduledRouteKey.current = ''
      window.clearTimeout(timeoutId)
    }
  }, [access, hydrated, location, routeKey, user])

  return null
}

AnalyticsPageviewTracker.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
}

export default AnalyticsPageviewTracker
